import React from "react";
import { Modal, Button, DatePicker, Form, message, notification } from "antd";
import dayjs from "dayjs";
import { retrieveData, triggerNotification, useSelector } from "../../../common/CommonExport";


const ModalLopDownload = ({
  open,
  handleClose,
}: {
  open: boolean;
  handleClose: () => void;
}) => {
  const lopBaseUrl = process.env.REACT_APP_LOP_BASE_PATH

  const [form] = Form.useForm();
  const [loading, setLoading] = React.useState(false);
  const organisationId = useSelector((state: any) => state?.organisationId?.id);
  const handleDownload = async () => {
    try {
      const values = await form.validateFields();

      const selectedMonth: dayjs.Dayjs = values.month;
      const monthYear = selectedMonth.format("MM-YYYY");
      const token: string = retrieveData("authToken", true);

      const apiUrl = `${lopBaseUrl}/admin/leave-management/geo-attendance/lop-calculator?organisationId=${organisationId}&month=${monthYear}`;

      setLoading(true);
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          Accept: "text/csv",
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) throw new Error("Failed to download report");

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `LOP-Report-${monthYear}.csv`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      handleClose();
      form.resetFields();
    } catch (error: any) {
      if (!error?.errorFields) {
        triggerNotification(
          "error",
          "Failed to download report.",
          "",
          "topRight",
          3
        );
      }

    } finally {
      setLoading(false);
    }
  };


  return (
    <Modal
      title="Download LOP Report"
      open={open}
      onCancel={handleClose}
      footer={null}
      destroyOnClose
      centered
      style={{ maxWidth: 480 }}
      bodyStyle={{ padding: "24px" }}
    >
      <Form layout="vertical" form={form}>
        <Form.Item
          label="Select Month & Year"
          name="month"
          rules={[{ required: true, message: "Please select a month and year" }]}
        >
          <DatePicker
            picker="month"
            format="MMM YYYY"
            style={{ width: "100%" }}
            placeholder="Select month and year"
            disabledDate={(current) => current && current > dayjs().endOf("month")}
          />
        </Form.Item>

        <div className="flex justify-center mt-8">
          <Button
            type="primary"
            onClick={handleDownload}
            loading={loading}
            className="addButton px-6 w-30">
            Download Report
          </Button>


        </div>
      </Form>
    </Modal>
  );
};

export default ModalLopDownload;
